import { PaymentOrchestrationError } from "./PaymentOrchestrationError";
import { PaymentErrorCategories } from "./PaymentErrorCategories";

/**
 * Error thrown for unexpected system failures or programming errors.
 * This includes unimplemented methods, invalid data states, and other system-level issues.
 * Usually not recoverable without code changes.
 */
export class PaymentSystemError extends PaymentOrchestrationError {
  readonly category = PaymentErrorCategories.SYSTEM;
  readonly recoverable = false;

  constructor(
    technicalMessage: string,
    options?: {
      userMessage?: string;
      metadata?: Record<string, unknown>;
    }
  ) {
    super(technicalMessage, {
      userMessage:
        options?.userMessage ||
        "Something unexpected happened. Please try again or contact support.",
      metadata: options?.metadata,
    });
  }
}
